import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { updateSegment } from '../../../redux/currentSearch/actions';
import { getSegmentConfig, getOriginErrorSelector } from '../../../redux/currentSearch/selectors';
import { useSegmentContext } from './SegmentManager/Context';
import { SegmentConfigType, SegmentPropDefault } from '../../../models';

export const SegmentDeparture = ({ children, updateSegment, originError, segmentConfig }) => {
    const { segment } = useSegmentContext();
    const value = segment.origin;
    const isDisabled = !segmentConfig.origin.enabled;

    const setValue = (origin) => {
        if (origin !== value) {
            updateSegment({ origin }, segment.id);
        }
    };

    return children({ error: originError, setValue, value, isDisabled });
};

SegmentDeparture.propTypes = {
    children: PropTypes.func.isRequired,
    updateSegment: PropTypes.func.isRequired,
    segmentConfig: SegmentConfigType.isRequired,
};

SegmentDeparture.defaultProps = {
    children: null,
    updateSegment: () => {},
    segmentConfig: SegmentPropDefault,
};

const mapStateToPropsSelector = createStructuredSelector({
    originError: getOriginErrorSelector,
    segmentConfig: getSegmentConfig,
});

export const ConnectedSegmentDeparture = connect(mapStateToPropsSelector, {
    updateSegment,
})(SegmentDeparture);
